/* unplugin-vue-components disabled */import { render } from "./ErrorLogger.vue?vue&type=template&id=579090b0"
import script from "./ErrorLogger.vue?vue&type=script&lang=js"
export * from "./ErrorLogger.vue?vue&type=script&lang=js"

import exportComponent from "E:\\projects\\internation-fta-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__